export default __webpack_public_path__ + "images/e266cc49e059eb6c98a9fe4b8dd25046-truemed.svg";